export default __webpack_public_path__ + "static/logo-blue-1-7b6550a37174f589d6ec164b4d2d4606.png";